import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-http-client';

@inject(HttpClient)
export class VerbiageSettingAPI {

    constructor(http) {
        this.http = http;
    }

    saveVerbiage(data,token, successCallback, errorCallback) {

        var formData = new FormData();
        formData.append('data', JSON.stringify(data));

        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/verbiage/save', formData)
        .then(data => {

            if (data.isSuccess) {
                var json = JSON.parse(data.response);
                successCallback(json);
                
            }
            else {
                errorCallback();
            }
        });

    }

    getVerbiageSettings(data,token, successCallback, errorCallback) {

        var formData = new FormData();
        formData.append('data', JSON.stringify(data));

        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.get('api/verbiage/get', formData)
        .then(data => {

            if (data.isSuccess) {
                var json = JSON.parse(data.response);
                console.log(json);
                successCallback(json);
                
            }
            else {
                errorCallback();
            }
        });

    }
}
